import React, { useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api_editProduct } from '../../../api/product';
import { api_getCategories } from '../../../api/category';
import { SelectAsyncPaginate } from './AddProduct';
import { toast } from 'react-hot-toast';
import { myToastWarning } from '../../../helpers/myToast';
import { getImageUrl } from '../../../api';
interface SubCategory {
	_id: string;
	name: string;
}

const EditProduct = () => {
	const product = useLocation().state;
	const [loading, setLoading] = useState(false);
	const [image, setImage] = useState(product.image || null);
	const [name, setName] = useState(product.name || '');
	const [quantity, setQuantity] = useState(product.quantity || '1');
	const [onSalePrice, setOnSalePrice] = useState(product?.onSalePrice?.amount || '1');
	const [retailPrice, setRetailPrice] = useState(product?.retailPrice?.amount || '1');
	const [des, setDes] = useState(product.description || '');
	const [allCategory, setAllCategory] = useState<any>(null);
	const [selectedCategory, setSelectedCategory] = useState<any>(product.category.main || null);
	const [selectedSubCategory, setSelectedSubCategory] = useState<any>(
		product.category.sub || null,
	);
	const [selectedSubSubCategory, setSelectedSubSubCategory] = useState<any>(null);
	const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState<any>(null);

	const loadOptions = useCallback(async (additional = { page: 1 }) => {
		try {
			const { page } = additional;
			const res = await api_getCategories(page, 10);
			// console.log(res);
			setAllCategory(res.data);
			return {
				options: res.data || [],
			};
		} catch (error) {
			console.error('Error loading main categories:', error);
			return { options: [] };
		}
	}, []);
	const loadSubOptions = useCallback(
		async (additional = { page: 1 }) => {
			try {
				const { page } = additional;
				console.log('Selected Category:', selectedCategory);

				if (!selectedCategory) {
					return { options: [] };
				}

				// Find the selected category in allCategory
				const selectedCategoryObj = allCategory.find(
					(category: { _id: any }) => category._id === selectedCategory._id,
				);

				if (!selectedCategoryObj || !selectedCategoryObj.subCategories) {
					return { options: [] };
				}

				console.log('Selected Category:', selectedCategoryObj);

				return {
					options: selectedCategoryObj.subCategories || [],
				};
			} catch (error) {
				console.error('Error loading sub categories:', error);
				return { options: [] };
			}
		},
		[selectedCategory, allCategory], // Ensure allCategory is in the dependency array
	);

	const loadSubSubOptions = useCallback(
		async (additional = { page: 1 }) => {
			try {
				const { page } = additional;

				if (!selectedCategory) {
					return { options: [] };
				}

				// Find the selected category in allCategory
				const selectedCategoryObj = allCategory.find(
					(category: { _id: any }) => category._id === selectedCategory._id,
				);

				if (!selectedCategoryObj || !selectedCategoryObj.subCategories) {
					return { options: [] };
				}

				// Find the selected subcategory within the selected category
				const selectedSubCategoryObj = selectedCategoryObj.subCategories.find(
					(subCategory: { _id: any }) => subCategory._id === selectedSubCategory._id,
				);

				if (!selectedSubCategoryObj || !selectedSubCategoryObj.subSubCategories) {
					return { options: [] };
				}

				return {
					options: selectedSubCategoryObj.subSubCategories || [],
				};
			} catch (error) {
				console.error('Error loading sub sub categories:', error);
				return { options: [] };
			}
		},
		[allCategory, selectedCategory, selectedSubCategory._id], // Ensure allCategory is in the dependency array
	);

	const loadSubSubSubOptions = useCallback(
		async (additional = { page: 1 }) => {
			try {
				const { page } = additional;

				if (!selectedCategory || !selectedSubCategory || !selectedSubSubCategory) {
					return { options: [] };
				}

				// Find the selected category in allCategory
				const selectedCategoryObj = allCategory.find(
					(category: { _id: any; }) => category._id === selectedCategory._id,
				);

				if (!selectedCategoryObj || !selectedCategoryObj.subCategories) {
					return { options: [] };
				}

				// Find the selected subcategory within the selected category
				const selectedSubCategoryObj = selectedCategoryObj.subCategories.find(
					(subCategory: { _id: any; }) => subCategory._id === selectedSubCategory._id,
				);

				if (!selectedSubCategoryObj || !selectedSubCategoryObj.subSubCategories) {
					return { options: [] };
				}

				// Find the selected subsubcategory within the selected subcategory
				const selectedSubSubCategoryObj = selectedSubCategoryObj.subSubCategories.find(
					(subSubCategory: { _id: any; }) => subSubCategory._id === selectedSubSubCategory._id,
				);

				if (!selectedSubSubCategoryObj || !selectedSubSubCategoryObj.subSubSubCategories) {
					return { options: [] };
				}

				return {
					options: selectedSubSubCategoryObj.subSubSubCategories || [],
				};
			} catch (error) {
				console.error('Error loading sub sub sub categories:', error);
				return { options: [] };
			}
		},
		[allCategory, selectedCategory, selectedSubCategory, selectedSubSubCategory], // Ensure allCategory is in the dependency array
	);

	const navigate = useNavigate();

	const edit = async () => {
		if (!quantity) {
			myToastWarning('Please Enter Quantity');
			return;
		}
		if (!name) {
			myToastWarning('Please Enter Name');
			return;
		}

		try {
			setLoading(true);
			const payload = new FormData();
			payload.append('name', name);
			payload.append('description', des);
			payload.append('quantity', quantity);
			payload.append('onSalePrice.amount', onSalePrice);
			payload.append('onSalePrice.prefix', '$');
			payload.append('onSalePrice.currency', 'globaly');
			payload.append('retailPrice.amount', retailPrice);
			payload.append('retailPrice.prefix', 'Br');
			payload.append('retailPrice.currency', 'local');

			if (selectedCategory) payload.append('category.main', selectedCategory._id);
			if (selectedSubCategory) payload.append('category.sub', selectedSubCategory._id);
			if (selectedSubSubCategory)
				payload.append('category.subsub', selectedSubSubCategory._id);
			if (selectedSubSubSubCategory)
				payload.append('category.subsubsub', selectedSubSubSubCategory._id);

			if (image) payload.append('image', image);
			console.log(payload);

			const res = await api_editProduct(payload, product._id);
			const message = typeof res.message === 'string' ? res.message : 'Success';

			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate(-1);
				}, 100);
			} else {
				toast.error(message);
			}
		} catch (error) {
			console.error('Error editing product:', error);
			toast.error('Error editing product');
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		loadOptions();
	});

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<h3>Edit Product</h3>
			</div>

			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Name
				</label>
				<input
					value={name}
					onChange={(e) => setName(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Price In Dollar
				</label>
				<input
					value={onSalePrice}
					type='number'
					onChange={(e) => setOnSalePrice(Number(e.target.value))}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Price In Ethiopian Birr
				</label>
				<input
					value={retailPrice}
					type='number'
					onChange={(e) => setRetailPrice(Number(e.target.value))}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Qty
				</label>
				<input
					value={quantity}
					type='number'
					onChange={(e) => setQuantity(Number(e.target.value))}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='currentImage' className='form-label'>
					Current Image
				</label>
				{image && (
					<img
						src={getImageUrl(image)}
						alt='Current Banner'
						style={{ width: '400px', borderRadius: '8px', objectFit: 'cover' }}
						className='form-control form-control-sm'
					/>
				)}
			</div>
			<div className='mb-3'>
				<label htmlFor='formFileSm' className='form-label'>
					Product Image
				</label>
				<input
					// @ts-ignore
					onChange={(event) => setImage(event.target.files[0])}
					style={{ width: '400px' }}
					className='form-control form-control-sm'
					id='formFileSm'
					type='file'
				/>
			</div>
			<div className='mb-3' style={{ width: '400px' }}>
				<label htmlFor='formFileSm' className='form-label'>
					Product Category
				</label>
				<SelectAsyncPaginate
					onChange={setSelectedCategory}
					value={selectedCategory}
					loadOptions={loadOptions}
				/>
			</div>
			{/* Render subcategories if they exist */}
			{selectedCategory?.subCategories?.length > 0 && (
				<div className='mb-3' style={{ width: '400px' }}>
					<label htmlFor='formFileSm' className='form-label'>
						Sub Product Category
					</label>
					<SelectAsyncPaginate
						onChange={setSelectedSubCategory}
						value={selectedSubCategory}
						loadOptions={loadSubOptions}
					/>
				</div>
			)}
			{selectedSubCategory?.subSubCategories?.length > 0 && (
				<div className='mb-3' style={{ width: '400px' }}>
					<label htmlFor='formFileSm' className='form-label'>
						Sub Sub Product Category
					</label>
					<SelectAsyncPaginate
						onChange={setSelectedSubSubCategory}
						value={selectedSubSubCategory}
						loadOptions={loadSubSubOptions}
					/>
				</div>
			)}
			{selectedSubSubCategory?.subSubSubCategories?.length > 0 && (
				<div className='mb-3' style={{ width: '400px' }}>
					<label htmlFor='formFileSm' className='form-label'>
						Sub Sub Sub Product Category
					</label>
					<SelectAsyncPaginate
						onChange={setSelectedSubSubSubCategory}
						value={selectedSubSubSubCategory}
						loadOptions={loadSubSubSubOptions}
					/>
				</div>
			)}
			<div className='mb-3'>
				<label htmlFor='exampleFormControlTextarea1' className='form-label'>
					Description
				</label>
				<textarea
					value={des}
					onChange={(e) => setDes(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlTextarea1'
					rows={3}
				/>
			</div>
			<button
				onClick={edit}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading}>
				{loading ? 'Loading..' : 'Submit'}
			</button>
		</div>
	);
};

export default EditProduct;
